import React from 'react';
import PropTypes from 'prop-types';
import DownloadPDF from 'components/button/DownloadPDF';
import DropDownButton from '../DropDownButton';
import SendVoucher from './SendVoucher';
import translate from 'components/hoc/translate';
import { downladBookingVoucherRequest } from 'http/requests/bookings/bookingDownloadRequests';
import { downloadVoucherFailure } from 'store/actions/voucherActions';

const VoucherActions = (props) => {
    const { id, orderId, translate, toggleVoucherModal } = props;

    const buttonStyle = { borderRadius: '0' };

    return (
        <DropDownButton title={ translate('resources.orders.voucher.title') } >
            <SendVoucher style={ buttonStyle } toggleVoucherModal={ toggleVoucherModal } />
            <DownloadPDF
                failureAction={ downloadVoucherFailure }
                fileName={ `booking_${ orderId }_voucher.pdf` }
                id={ id }
                request={ downladBookingVoucherRequest }
                style={ buttonStyle }
                title={ translate('resources.orders.voucher.download.title') }
            />
        </DropDownButton>
    );
};

VoucherActions.propTypes = {
    id: PropTypes.number.isRequired,
    orderId: PropTypes.number.isRequired,
    toggleVoucherModal: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(VoucherActions);



// WEBPACK FOOTER //
// ./src/components/button/Voucher/VoucherActions.js